<template>
    <v-card class="expense-card">
        <v-snackbar :color="color" :timeout="callbackResponse.timeout" top v-model="snackbar">
            {{ callbackResponse.message }}
            <v-btn @click="snackbar = false" dark text>Close</v-btn>
        </v-snackbar>
        <div class="sticky-toolbar">
            <v-toolbar class="toolbar" color="indigo" dark>
                <v-toolbar-title>
                    {{$t('view')}}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn @click="dialogueClose" dark icon>
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
        </div>
  
        <v-container>
            <div v-for="(tableDara, index) in tableData" :key="index">
                <div v-if="table && tableDara.headers.length>0" style="padding-top:3rem">
                    <h2 style="text-align:center">{{valueShow}} आ.ब.{{tableDara.showNextYear?YearPreviousCurrentNext.next:yearShow}}  को {{tableDara.reportTitle}}  </h2>


                    <table class="table tbl sticky-table-header">
                        <thead v-if="tableDara.groupLevel==1 || tableDara.groupLevel==2">
                            <tr>
                                <th rowspan="2">क्र सं</th>
                                <template v-for="(header,index) in tableDara.headers">
                                    <th :colspan="header.listCount" style="text-align:center" :key="index+'firstrowthead'"
                                        v-if=" header.groupID > 0 ">
                                        <span v-if="header.showYear=='Next' && header.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.next}}  {{ header.groupName }}
                                        </span>
                                        <span v-else-if="header.showYear=='Current' && header.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.current}}  {{ header.groupName }}
                                        </span>
                                        <span v-else-if="header.showYear=='Previous' && header.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.previous}}  {{ header.groupName }}
                                        </span>

                                        <!--NEW-->
                                        <span v-else-if="header.showYear=='TwoYear' && header.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ header.groupName }}
                                        </span>
                                        <span v-else-if="header.showYear=='ThreeYear' && header.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ header.groupName }}
                                        </span>
                                        <!--END NEW-->

                                        <span v-else> {{ header.groupName }}</span>

                                    </th>
                                    <template v-else>
                                        <template v-for="(column, count) in header.subList">
                                            <th rowspan="2" style="text-align:center" v-bind:key="index+'firstrowtheadelse'+count">
                                                <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                                </span>
                                                <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                                </span>
                                                <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                                </span>

                                                <!--NEW-->
                                                <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                                </span>
                                                <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                                </span>
                                                <!--END NEW-->

                                                <span v-else> {{ column.name }}</span>
                                            </th>
                                        </template>

                                    </template>
                                </template>
                            </tr>
                            <tr>
                                <template v-for="(column, secondIndex) in tableDara.colsHeaders">
                                    <th :key="'secondheaderrow'+secondIndex" style="text-align:center" v-if=" column.subTitleID>0 ">
                                        <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                        </span>

                                        <!--NEW-->
                                        <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                        </span>
                                        <!--NEW-->

                                        <span v-else> {{ column.name }}</span>
                                    </th>
                                </template>
                            </tr>
                        </thead>
                        <thead v-if="tableDara.groupLevel==3">
                            <tr>
                                <th rowspan="3">क्र सं</th>
                                <template v-for="(header,index) in tableDara.headers">

                                    <th :colspan="header.listCount" style="text-align:center" :key="index+'rowspan3ck'"
                                        v-if="header.groupID>0 ">

                                        <span v-if="header.showYear=='Next' && header.yearType=='Parent'">
                                            आ.ब. {{YearPreviousCurrentNext.next}}  {{ header.groupName }}
                                        </span>
                                        <span v-else-if="header.showYear=='Current' && header.yearType=='Parent'">
                                            आ.ब. {{YearPreviousCurrentNext.current}}  {{ header.groupName }}
                                        </span>
                                        <span v-else-if="header.showYear=='Previous' && header.yearType=='Parent'">
                                            आ.ब. {{YearPreviousCurrentNext.previous}}  {{ header.groupName }}
                                        </span>

                                        <!--NEW-->
                                        <span v-else-if="header.showYear=='TwoYear' && header.yearType=='Parent'">
                                            आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ header.groupName }}
                                        </span>
                                        <span v-else-if="header.showYear=='ThreeYear' && header.yearType=='Parent'">
                                            आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ header.groupName }}
                                        </span>
                                        <!--END-->

                                        <span v-else> {{ header.groupName }}</span>
                                    </th>
                                    <template v-else>
                                        <template v-for="(column, subindex) in header.list">
                                            <th :colspan="column.subList.length" rowspan="2" style="text-align:center"
                                                :key="index+'rowspan2rk'+subindex" v-if="header.groupID>0">
                                                <span v-if="column.showYear=='Next' && column.yearType=='Child'">
                                                    आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                                </span>
                                                <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                                    आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                                </span>
                                                <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                                    आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                                </span>

                                                <!--NEW-->
                                                <span v-else-if="column.showYear=='TwoYear' && column.yearType=='Child'">
                                                    आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                                </span>
                                                <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='Child'">
                                                    आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                                </span>
                                                <!--END NEW-->

                                                <span v-else> {{ column.name }}</span>
                                            </th>
                                            <template v-else v-for="(subColumn, innerindex) in column.subList">
                                                <th rowspan="3" style="text-align:center" :key="subindex+'subColumn2'+innerindex">
                                                    <span v-if="subColumn.showYear=='Next' && subColumn.yearType=='SubChild'">
                                                        आ.ब. {{YearPreviousCurrentNext.next}}  {{ subColumn.name }}
                                                    </span>
                                                    <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                                    </span>
                                                    <span v-else-if="subColumn.showYear=='Previous' && subColumn.yearType=='SubChild'">
                                                        आ.ब. {{YearPreviousCurrentNext.previous}}  {{ subColumn.name }}
                                                    </span>


                                                    <!--NEW-->
                                                    <span v-else-if="subColumn.showYear=='TwoYear' && subColumn.yearType=='SubChild'">
                                                        आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ subColumn.name }}
                                                    </span>
                                                    <span v-else-if="subColumn.showYear=='ThreeYear' && subColumn.yearType=='SubChild'">
                                                        आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ subColumn.name }}
                                                    </span>
                                                    <!--END NEW-->

                                                    <span v-else> {{ subColumn.name }}</span>
                                                </th>
                                            </template>
                                        </template>

                                    </template>
                                </template>
                            </tr>
                            <tr>
                                <template v-for="(column, index) in tableDara.subColumns">
                                    <th :colspan="column.subList.length" :key="'subColumn2las'+index" style="text-align:center"
                                        v-if="column.groupID>0 ">
                                        <span v-if="column.showYear=='Next' && column.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.groupName }}
                                        </span>
                                        <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.groupName }}
                                        </span>
                                        <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.groupName }}
                                        </span>

                                        <!--NEW-->
                                        <span v-else-if="column.showYear=='TwoYear' && column.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.groupName }}
                                        </span>
                                        <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.groupName }}
                                        </span>
                                        <!--END NEW-->

                                        <span v-else> {{ column.groupName }}</span>
                                    </th>
                                    <template v-for="(subColumn, interindex) in column.subList">
                                        <th :key="index+'subColumn3wer'+interindex" rowspan="2" style="text-align:center"
                                            v-if="subColumn.titleID>0 && column.groupID==null">
                                            <span v-if="subColumn.showYear=='Next' && subColumn.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.next}}  {{ subColumn.name }}
                                            </span>
                                            <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                            </span>

                                            <!--NEW-->
                                            <span v-else-if="subColumn.showYear=='TwoYear' && subColumn.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ subColumn.name }}
                                            </span>
                                            <span v-else-if="subColumn.showYear=='ThreeYear' && subColumn.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ subColumn.name }}
                                            </span>
                                            <!--END NEW-->

                                            <span v-else> {{ subColumn.name }}</span>
                                        </th>
                                    </template>
                                </template>
                            </tr>
                            <tr>
                                <template v-for="(column,index) in tableDara.colsHeaders">
                                    <th :key="'subColumn4ask'+index" style="text-align:center" v-if="column.subTitleID>0 ">
                                        <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                        </span>
                                        <!--NEW-->
                                        <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                        </span>
                                        <!--END NEW-->
                                        <span v-else> {{ column.name }}</span>
                                    </th>
                                </template>
                            </tr>
                        </thead>

                        <template v-for="(section,index) in tableDara.rows">
                            <tr :key="'row1mk'+index">
                                <td :colspan="tableDara.colsHeaders.length+1" style="background-color:#cdcdee;" v-if="section.reportSectionID>0">
                                    <span> {{index+1}}. {{section.reportSection}}</span>
                                </td>
                            </tr>
                            <template v-for="(subSection,properindex) in section.list">
                                <tr :key="properindex+'row2lk'+index">
                                    <td style="text-align:center">{{properindex+1}}</td>
                                    <td style="text-align:center">{{subSection.reportSubSection}}</td>
                                    <td :key="subindex+'main'+'row2col'+properindex" class="data-input" style="text-align:center"
                                        v-for="(rowsHeader, subindex) in subSection.list">
                                        <v-text-field dense @keypress="isNumber($event)" label="Amount" outlined
                                                      v-if="rowsHeader.dataType==2" v-model="rowsHeader.amount"
                                                      v-on:input="calculateTotal()"></v-text-field>
                                        <v-text-field dense @keypress="isNumber($event)" label="Quantity" outlined
                                                      v-else-if="rowsHeader.dataType==4" v-model="rowsHeader.amount"
                                                      v-on:input="calculateTotal()"></v-text-field>
                                        <v-text-field dense @keypress="isNumber($event)" label="Quantity 1" outlined
                                                      v-else-if="rowsHeader.dataType==6" v-model="rowsHeader.amount"
                                                      v-on:input="calculateTotal()"></v-text-field>
                                        <v-text-field dense @keypress="isNumber($event)" label="Total" outlined
                                                      v-else-if="rowsHeader.dataType==5"
                                                      v-model="rowsHeader.amount"></v-text-field>
                                        <v-text-field dense label="Text" outlined v-else v-model="rowsHeader.value"></v-text-field>
                                    </td>
                                </tr>
                            </template>
                        </template>
                        <tfoot>
                            <tr class="tfoot">
                                <td colspan="2"><b>कुल जम्मा</b></td>
                                <td :key="'totalindex'+index" v-for="(total,index) in tableDara.totals">
                                    <b v-if="total!=null">{{total.total}}</b>
                                </td>
                            </tr>
                        </tfoot>
                    </table>



                    <table class="table tbl" id="tblData" v-show="exportTbl">
                        <thead v-if="tableDara.groupLevel==1 || tableDara.groupLevel==2">
                            <tr>
                                <th rowspan="2">क्र सं</th>
                                <template v-for="(header,index) in tableDara.headers">
                                    <th :colspan="header.listCount" style="text-align:center" :key="index+'firstrowthead'"
                                        v-if=" header.groupID > 0 ">
                                        <span v-if="header.showYear=='Next' && header.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.next}}  {{ header.groupName }}
                                        </span>
                                        <span v-else-if="header.showYear=='Current' && header.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.current}}  {{ header.groupName }}
                                        </span>
                                        <span v-else-if="header.showYear=='Previous' && header.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.previous}}  {{ header.groupName }}
                                        </span>

                                        <!--NEW-->
                                        <span v-else-if="header.showYear=='TwoYear' && header.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ header.groupName }}
                                        </span>
                                        <span v-else-if="header.showYear=='ThreeYear' && header.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ header.groupName }}
                                        </span>
                                        <!--END NEW-->

                                        <span v-else> {{ header.groupName }}</span>

                                    </th>
                                    <template v-else>
                                        <template v-for="(column, count) in header.subList">
                                            <th rowspan="2" style="text-align:center" v-bind:key="index+'firstrowtheadelse'+count">
                                                <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                                </span>
                                                <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                                </span>
                                                <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                                </span>

                                                <!--NEW-->
                                                <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                                </span>
                                                <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                                </span>
                                                <!--END NEW-->

                                                <span v-else> {{ column.name }}</span>
                                            </th>
                                        </template>

                                    </template>
                                </template>
                            </tr>
                            <tr>
                                <template v-for="(column, secondIndex) in tableDara.colsHeaders">
                                    <th :key="'secondheaderrow'+secondIndex" style="text-align:center" v-if=" column.subTitleID>0 ">
                                        <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                        </span>

                                        <!--NEW-->
                                        <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                        </span>
                                        <!--END NEW-->

                                        <span v-else> {{ column.name }}</span>
                                    </th>
                                </template>
                            </tr>
                        </thead>
                        <thead v-if="tableDara.groupLevel==3">
                            <tr>
                                <th rowspan="3">क्र सं</th>
                                <template v-for="(header,index) in tableDara.headers">
                                    <th :colspan="header.listCount" style="text-align:center" :key="index+'rowspan3ck'"
                                        v-if="header.groupID>0 ">
                                        <span v-if="header.showYear=='Next' && header.yearType=='Parent'">
                                            आ.ब. {{YearPreviousCurrentNext.next}}  {{ header.groupName }}
                                        </span>
                                        <span v-else-if="header.showYear=='Current' && header.yearType=='Parent'">
                                            आ.ब. {{YearPreviousCurrentNext.current}}  {{ header.groupName }}
                                        </span>
                                        <span v-else-if="header.showYear=='Previous' && header.yearType=='Parent'">
                                            आ.ब. {{YearPreviousCurrentNext.previous}}  {{ header.groupName }}
                                        </span>

                                        <!--NEW-->
                                        <span v-else-if="header.showYear=='TwoYear' && header.yearType=='Parent'">
                                            आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ header.groupName }}
                                        </span>
                                        <span v-else-if="header.showYear=='ThreeYear' && header.yearType=='Parent'">
                                            आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ header.groupName }}
                                        </span>
                                        <!--END NEW-->
                                        <span v-else> {{ header.groupName }}</span>
                                    </th>
                                    <template v-else>
                                        <template v-for="(column, subindex) in header.list">
                                            <th :colspan="column.subList.length" rowspan="2" style="text-align:center"
                                                :key="index+'rowspan2rk'+subindex" v-if="header.groupID>0">
                                                <span v-if="column.showYear=='Next' && column.yearType=='Child'">
                                                    आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                                </span>
                                                <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                                    आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                                </span>
                                                <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                                    आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                                </span>

                                                <!--NEW-->
                                                <span v-else-if="column.showYear=='TwoYear' && column.yearType=='Child'">
                                                    आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                                </span>
                                                <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='Child'">
                                                    आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                                </span>
                                                <!--END NEW-->

                                                <span v-else> {{ column.name }}</span>
                                            </th>
                                            <template v-else v-for="(subColumn, innerindex) in column.subList">
                                                <th rowspan="3" style="text-align:center" :key="subindex+'subColumn2'+innerindex">
                                                    <span v-if="subColumn.showYear=='Next' && subColumn.yearType=='SubChild'">
                                                        आ.ब. {{YearPreviousCurrentNext.next}}  {{ subColumn.name }}
                                                    </span>
                                                    <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                                    </span>
                                                    <span v-else-if="subColumn.showYear=='Previous' && subColumn.yearType=='SubChild'">
                                                        आ.ब. {{YearPreviousCurrentNext.previous}}  {{ subColumn.name }}
                                                    </span>

                                                    <!--NEW-->
                                                    <span v-else-if="subColumn.showYear=='TwoYear' && subColumn.yearType=='SubChild'">
                                                        आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ subColumn.name }}
                                                    </span>
                                                    <span v-else-if="subColumn.showYear=='ThreeYear' && subColumn.yearType=='SubChild'">
                                                        आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ subColumn.name }}
                                                    </span>
                                                    <!--END NEW-->

                                                    <span v-else> {{ subColumn.name }}</span>
                                                </th>
                                            </template>
                                        </template>

                                    </template>
                                </template>
                            </tr>
                            <tr>
                                <template v-for="(column, index) in tableDara.subColumns">
                                    <th :colspan="column.subList.length" :key="'subColumn2las'+index" style="text-align:center"
                                        v-if="column.groupID>0 ">
                                        <span v-if="column.showYear=='Next' && column.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.groupName }}
                                        </span>
                                        <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.groupName }}
                                        </span>
                                        <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.groupName }}
                                        </span>
                                        <!--NEW-->
                                        <span v-else-if="column.showYear=='TwoYear' && column.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.groupName }}
                                        </span>
                                        <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.groupName }}
                                        </span>
                                        <!--END NEW-->
                                        <span v-else> {{ column.groupName }}</span>
                                    </th>
                                    <template v-for="(subColumn, interindex) in column.subList">
                                        <th :key="index+'subColumn3wer'+interindex" rowspan="2" style="text-align:center"
                                            v-if="subColumn.titleID>0 && column.groupID==null">
                                            <span v-if="subColumn.showYear=='Next' && subColumn.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.next}}  {{ subColumn.name }}
                                            </span>
                                            <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                            </span>
                                            <span v-else-if="subColumn.showYear=='Previous' && subColumn.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.previous}}  {{ subColumn.name }}
                                            </span>

                                            <!--NEW-->
                                            <span v-else-if="subColumn.showYear=='TwoYear' && subColumn.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ subColumn.name }}
                                            </span>
                                            <span v-else-if="subColumn.showYear=='ThreeYear' && subColumn.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ subColumn.name }}
                                            </span>
                                            <!--END NEW-->
                                            <span v-else> {{ subColumn.name }}</span>
                                        </th>
                                    </template>
                                </template>
                            </tr>
                            <tr>
                                <template v-for="(column,index) in tableDara.colsHeaders">
                                    <th :key="'subColumn4ask'+index" style="text-align:center" v-if="column.subTitleID>0 ">
                                        <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                        </span>

                                        <!--NEW-->
                                        <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                        </span>
                                        <!--END NEW-->

                                        <span v-else> {{ column.name }}</span>
                                    </th>
                                </template>
                            </tr>
                        </thead>

                        <template v-for="(section,index) in tableDara.rows">
                            <tr :key="'row1mk'+index">
                                <td :colspan="tableDara.colsHeaders.length+1" style="background-color:#cdcdee;" v-if="section.reportSectionID>0">
                                    <span> {{index+1}}. {{section.reportSection}}</span>
                                </td>
                            </tr>
                            <template v-for="(subSection,properindex) in section.list">
                                <tr :key="properindex+'row2lk'+index">
                                    <td style="text-align:center">{{properindex+1}}</td>
                                    <td style="text-align:center">{{subSection.reportSubSection}}</td>
                                    <td :key="subindex+'main'+'row2col'+properindex" class="data-input" style="text-align:center"
                                        v-for="(rowsHeader, subindex) in subSection.list">
                                        <v-span v-if="rowsHeader.dataType==2">{{rowsHeader.amount}}</v-span>
                                        <v-span label="Quantity" outlined
                                                v-else-if="rowsHeader.dataType==4">{{rowsHeader.amount}}</v-span>
                                        <v-span label="Quantity" outlined
                                                v-else-if="rowsHeader.dataType==6">{{rowsHeader.amount}}</v-span>
                                        <v-span label="Total" outlined
                                                v-else-if="rowsHeader.dataType==5">{{rowsHeader.amount}}</v-span>
                                        <v-span label="Text" outlined v-else>{{rowsHeader.value}}</v-span>
                                    </td>
                                </tr>
                            </template>
                        </template>
                        <tfoot>
                            <tr class="tfoot">
                                <td colspan="2"><b>कुल जम्मा</b></td>
                                <td :key="'totalindex'+index" v-for="(total,index) in tableDara.totals">
                                    <b v-if="total!=null">{{total.total}}</b>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>

            </div>

        </v-container>
    </v-card>
</template>

<script>
    import { required } from "vuelidate/lib/validators";
    import axios from "axios";

    export default {
        name: 'ViewComponent',
        watch: {
            "logData": {
                handler: async function () {
                    this.$emit("logDataResponse", this.logData)
                },
                deep: true
            },
        },
        computed: {
            isCompany() {
                let check = this.role == "SuperAdmin"
                return check
            },
            isDepartment() {
                let check = this.role == "Company" || this.role == "SuperAdmin"
                return check
            },
            isBranch() {
                let check = this.role == "Company" || this.role == "SuperAdmin" || this.tokenData.role == "Department"
                return check
            },
            companyIDErrors() {
                const errors = [];
                if (!this.$v.logData.companyID.$dirty) return errors;
                !this.$v.logData.companyID.required &&
                    errors.push("Company is required.");
                return errors;
            },
            yearErrors() {
                const errors = [];
                if (!this.$v.logData.year.$dirty) return errors;
                !this.$v.logData.year.required &&
                    errors.push("Year is required.");
                return errors;
            },
        },
        props: ['viewData'],
        components: {},
        data() {
            return {
                panelData: [0, 1],
                selectedStatus: {
                    company: "",
                    branch: ""
                },
                error: false,
                callbackResponse: {
                    timeout: 6000,
                    message: ""
                },
                status: {
                    isCompany: false,
                    isDepartment: false,
                },
                expenses: {
                    monthID: "4",
                    amount: 0,
                    remarks: "",
                    workingStatus: "1",
                    companyID: 0,
                    branchID: 0,
                    depoID: 0,
                },
                logData: {
                    companyID: 0,
                    departmentID: 0,
                    branchID: 0,
                    depoID: 0,
                    reportID: 0,
                    year: "2081",
                    reportLogID: 0,
                    isActive: null
                },
                table: false,
                tableIndex: 0,
                dialogCreate: false,
                snackbar: false,
                monthList: [],
                data: [],
                breadCrumbs: [],
                IsActive: false,
                TotalHeaderIndex: 0,
                rows: [],
                reportID: 0,
                reportTitle: "",
                totalRows: [],
                headers: [],
                colsHeaders: [],
                groupLevel: 0,
                totals: [],
                reportList: [],
                reportLogs: [],
                subColumns: [],
                yearList: [],
                fiscalYearList: [],
                titleHeaders: [],
                listDatas: [],
                listDDLData: [],
                user: {},
                tableView: false,
                tableFormData: [],
                expensesReport: [],
                helpData: [],
                radioColors: ['#47bf88de', '#FF5733', '#3A89F1', '#9C27B0'],
                serverData: {
                    companyID: null,
                    departmentID: null,
                    branchID: null,
                    depoID: null,
                    reportID: parseInt(this.$route.params.id),
                    year: "",
                    reportLogID: 0
                },
                serverParams: {
                    search: "",
                    columnFilters: {},
                    sort: [
                        {
                            field: "reportID",
                            type: "desc"
                        }
                    ],
                    page: 1,
                    perPage: 10
                },
                tableData: [],
                role: this.$store.getters.getUserRole,
                userData: this.$store.getters.getUserData,
                workStatusList: [],
                color: ""
            };
        },
        validations: {
            logData: {
                companyID: { required },
                year: { required },
            }
        },
        mounted() {
            this.loadData();
        },

        methods: {
            dialogueClose() {
                this.tableData = [],
                this.$emit("formResponse", this.servicesData);
            },
            loadData() {
                axios.get("ReportSettings/GetReportYearList").then(response => {
                    this.fiscalYearList = response.data
                    this.yearList = response.data
                })
                let data = this.viewData
                for (let i = 0; i < data.length; i++) {

                    this.logBtnData(data[i], data[i].yearID,[i])
                }
            },
            logBtnData(row, year, index) {
                console.log(row)
                this.logData.companyID = row.companyID
                this.logData.reportLogID = row.reportLogID
                this.helpData = row
                if (this.logData.companyID) {
                    this.getDdlData(this.logData.companyID, 'company');
                    this.logData.branchID = this.helpData.branchID
                    if (this.logData.branchID) {
                        this.getDdlData(this.logData.branchID, 'branch')
                        this.logData.depoID = this.helpData.depoID
                        if (this.logData.depoID) {
                            this.getDdlData(this.logData.depoID, 'depo')
                        }
                    }
                }

                this.logData.departmentID = this.helpData.departmentID
                this.logData.year = year
                if (row.departmentID > 0) {
                    this.valueShow = row.departmentName
                } else if (row.depoID > 0) {
                    this.valueShow = row.depoName
                } else if (row.branchID > 0) {
                    this.valueShow = row.branchName
                } else {
                    this.valueShow = row.companyName
                }
                this.yearShow = row.yearName
                var data = {
                    "reportLogID": parseInt(row.reportLogID),
                    "year": JSON.stringify(year),
                    "departmentID": parseInt(row.departmentID),
                    "depoID": parseInt(row.depoID),
                    "branchID": parseInt(row.branchID),
                    "companyID": parseInt(row.companyID),
                    "reportID": row.reportID,
                    "levelID": row.level,
                    "isQuarterly": row.isQuarterly
                }
                this.serverData = data;
                this.table = true

                this.currentFormApproved = row.isFinalized
                this.getColsRow(this.serverData)
                this.tableIndex = index
            },
            getColsRow(data) {
                const currentYearIndex = this.indexWhere(this.yearList, item => item.value === data.year)
                let previousThreeYearIndex = currentYearIndex - 3;
                let previousTwoYearIndex = currentYearIndex - 2;
                let previousYearIndex = currentYearIndex - 1;
                let nextYearIndex = currentYearIndex + 1;
                let previousCurrentNext = {};

                this.yearList.forEach(function (data, yearIndex) {


                    if (currentYearIndex == yearIndex) {
                        previousCurrentNext.current = data.id
                    }
                    //NEW
                    if (previousTwoYearIndex == yearIndex) {
                        previousCurrentNext.twoYear = data.id
                    }
                    if (previousThreeYearIndex == yearIndex) {
                        previousCurrentNext.threeYear = data.id
                    }
                    //end NEW
                    if (previousYearIndex == yearIndex) {
                        previousCurrentNext.previous = data.id
                    }
                    if (nextYearIndex == yearIndex) {
                        previousCurrentNext.next = data.id
                    }

                })
                //data.depoID = data.depoID,
                //    data.branchID = data.branchID,
                //    data.companyID = data.companyID
                //if (data.depoID == "") {
                //    data.depoID = null
                //}

                this.YearPreviousCurrentNext = previousCurrentNext;
                axios.post('ReportSettings/GetApprovalBudgetFinalColsRows', data).then(response => {
                    const dataObject = {
                        rows: response.data.rows,
                        headers: response.data.groupedColumns,
                        totals: response.data.total,
                        colsHeaders: response.data.columns,
                        reportID: response.data.reportID,
                        reportTitle: response.data.reportTitle,
                        groupLevel: response.data.groupLevel,
                        subColumns: response.data.subColumns,
                        showNextYear: response.data.showNextYear,
                    };

                    // Append the data object to the tableData array
                    this.tableData.push(dataObject);
                })
            },
            indexWhere(array, conditionFn) {
                const item = array.find(conditionFn)
                return array.indexOf(item)
            },
            getDdlData(data, val) {

                let formVal = {}
                if (val == "company") {
                    this.listDDLData.branchList = []
                    this.listDDLData.depoList = []
                    this.listDDLData.departmentCompanyList = []
                    this.listDDLData.departmentBranchList = []
                    this.listDDLData.departmentDepoList = []
                    this.logData.branchID = 0
                    this.logData.depoID = 0
                    this.logData.departmentID = 0
                    formVal = {
                        companyID: this.logData.companyID
                    }
                    axios.get("Branch/DDLBranchList", {
                        params: formVal
                    }).then(response => {
                        this.listDDLData.branchList = response.data
                    })

                    axios.post('Department/DDLDepartmentList', formVal).then(response => {
                        this.listDDLData.departmentCompanyList = response.data
                    })

                } else if (val == "branch") {
                    this.listDDLData.depoList = []
                    this.listDDLData.departmentBranchList = []
                    this.listDDLData.departmentDepoList = []
                    this.logData.depoID = ""
                    this.logData.departmentID = 0

                    formVal = {
                        branchID: this.logData.branchID
                    }
                    axios.get("Depo/DDLDepoList", {
                        params: formVal
                    }).then(response => {
                        this.listDDLData.depoList = response.data
                    })

                    axios.post('Department/DDLDepartmentList', formVal).then(response => {
                        this.listDDLData.departmentBranchList = response.data
                    })


                } else if (val == "depo") {
                    this.listDDLData.departmentDepoList = []
                    this.logData.departmentID = 0

                    formVal = {
                        depoID: this.logData.depoID
                    }
                    axios.post('Department/DDLDepartmentList', formVal).then(response => {
                        this.listDDLData.departmentDepoList = response.data
                    })
                }

            },

        }
    };
</script>

<style lang="scss" scoped>

    .v-sheet--offset {
        top: -24px;
        position: relative;
    }

    .tbl th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: $main-color;
        color: white;
    }

    table, td, th {
        border: 1px solid #ddd;
        text-align: left;
    }

    table {
        border-collapse: collapse;
        width: 100%;
    }

    th, td {
        padding: 15px;
    }
</style>

